import React, { Component } from 'react';
import Routes from '../../routes';
import { Ingreso, GetVersion } from '../../request/rfc';

export default class Login extends Component {

    constructor(props) {
        super(props);
        this.state = {
            baseUrl: document.getElementById('baseUrl').value,
            user: '',
            password: '',
            version: ''
        };
        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    componentDidMount() {
        GetVersion()
            .then(({ data: resp }) => {

                this.setState({ version: resp })

            })
            .catch((err) => { console.log(err); });
    }
    onChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
        console.log('name', name);
    }

    onSubmit(e) {
        e.preventDefault();
        const { user, password } = this.state;
        Ingreso({ pUsuario: user, pPassword: password })
            .then(({data: Response}) => {
                const { Message, Data } = Response;
                console.log(Message);
                
                if (Message !== '') {
                    console.log(Message);
                    alert(Message);
                } else {
                    if (Data.Mensaje !== '') {
                        alert(Data.Mensaje);
                    } else {
                        this.props.history.replace(`${this.state.baseUrl}${Routes.Home}`);
                    }
                }
            })
            .catch((err) => { console.log(err); });
    }

    render() {
        const style = { 'maxWidth': '500px', 'padding': '15px', 'margin': 'auto' };
        return (
            <div className="row">
                <div className="col-12">
                    <div className="row">
                        <div className="col-12">
                            <form id="frmlogin" className="form-signin" onSubmit={this.onSubmit}  style={style}>
                                <h1 className="h3 mb-3 font-weight-normal">Ingreso al Sistema</h1>
                                <label htmlFor="user" className="sr-only">Nombre Usuario:</label>
                                <input type="text" id="user" name="user" className="form-control" onChange={this.onChange} required autoFocus />
                                <label htmlFor="password" className="sr-only">Contraseña:</label>
                                <input type="password" id="password" name="password" className="form-control" onChange={this.onChange} placeholder="**********" required />
                                <button className="btn btn-custom-theme btn-block" type="submit"><i className="fas fa-sign-in-alt"></i></button>
                                <p className="mt-5 mb-3 text-muted">© {new Date().toLocaleDateString()} , Versión {this.state.version}</p>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./Public/src/js/component/login/index.jsx